import axios from 'axios';
import buildUrl from 'build-url';
import _ from 'lodash';

import { processRequest } from 'services/filters.service';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const SEARCH_URL = `${apiUrl}/api/2.0/content-mappings/search`;

const PAGE_SIZE = 100;

export const resolveDynamicContentMappingId = (record) =>
  _.get(record, 'id') || _.get(record, 'content.id') || null;

/** All content-mapping ids that match the current dynamic grid filters (for personalization prune). */
export const fetchFilteredContentMappingIds = async ({
  storyboardId,
  filters,
  sort,
  order,
}) => {
  const commands = (processRequest(filters) || []).filter((item) => {
    if (item.operator === 'IS_ALL') return true;
    return Array.isArray(item.value) && item.value.length > 0;
  });

  if (commands.length === 0) {
    return [];
  }

  const body = {
    storyboard: storyboardId,
    commands,
    sort,
    order,
  };

  const ids = [];
  let page = 0;
  let totalPages = 1;

  while (page < totalPages) {
    const url = buildUrl(SEARCH_URL, {
      queryParams: { page: String(page), limit: String(PAGE_SIZE) },
    });
    const { data } = await axios.post(url, body);
    const records = data?.records || [];
    records.forEach((record) => {
      const id = resolveDynamicContentMappingId(record);
      if (id) ids.push(id);
    });
    totalPages = data?.totalPages ?? 1;
    page += 1;
  }

  return _.uniq(ids);
};
